import { render, staticRenderFns } from "./AdvancedSettings.vue?vue&type=template&id=470c9415&scoped=true"
import script from "./AdvancedSettings.vue?vue&type=script&lang=js"
export * from "./AdvancedSettings.vue?vue&type=script&lang=js"
import style0 from "./AdvancedSettings.vue?vue&type=style&index=0&id=470c9415&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470c9415",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('470c9415')) {
      api.createRecord('470c9415', component.options)
    } else {
      api.reload('470c9415', component.options)
    }
    module.hot.accept("./AdvancedSettings.vue?vue&type=template&id=470c9415&scoped=true", function () {
      api.rerender('470c9415', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AdvancedSettings.vue"
export default component.exports